export enum AppEvent {
  SHOW_UPDATE_VERSION = 'app_update_modal_view',
  SKIP_UPDATE_VERSION = 'app_update_modal_skip',
  ACCEPT_UPDATE_VERSION = 'app_update_modal_CTA',
}
